import { Database01Icon } from '@langchain/untitled-ui-icons';

import { useNavigate } from 'react-router-dom';

import { DatasetCrudPaneWithButton } from '@/components/DatasetCrudPane/DatasetCrudPaneWithButton';
import { DatasetsTable } from '@/components/DatasetsTable';
import EmptyState from '@/components/EmptyState';
import { appDatasetsPath } from '@/utils/constants';

import { DEFAULT_PAGINATION_MODEL } from '../constants';

export function HomeDatasetsTable() {
  const navigate = useNavigate();

  return (
    <DatasetsTable
      simple={true}
      defaultPaginationModel={DEFAULT_PAGINATION_MODEL}
      emptyState={
        <div className="p-4">
          <EmptyState
            title="No datasets found"
            description="Start by creating a new dataset to run experiments"
            action={
              <DatasetCrudPaneWithButton
                onSuccess={(id) => navigate(`${appDatasetsPath}/${id}`)}
              />
            }
            fancyIcon={true}
            icon={<Database01Icon />}
          />
        </div>
      }
    />
  );
}
